import React from 'react';
import { SimpleSelect } from '@instructure/ui-simple-select';
import { Text } from '@instructure/ui-text';
import { View } from '@instructure/ui-view';
import t from 'format-message';
import { OutcomeArrangement } from "../../../../util/gradebook/constants.js";
export var OutcomeArrangementSelector = function OutcomeArrangementSelector(_ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? OutcomeArrangement.UPLOAD_ORDER : _ref$value,
    onChange = _ref.onChange;
  var options = [{
    id: OutcomeArrangement.ALPHABETICAL,
    value: OutcomeArrangement.ALPHABETICAL,
    name: t('Alphabetical')
  }, {
    id: OutcomeArrangement.CUSTOM,
    value: OutcomeArrangement.CUSTOM,
    name: t('Custom')
  }, {
    id: OutcomeArrangement.UPLOAD_ORDER,
    value: OutcomeArrangement.UPLOAD_ORDER,
    name: t('Upload Order')
  }];
  var handleChange = function handleChange(_event, data) {
    var selectedValue = data.value;
    if (Object.values(OutcomeArrangement).includes(selectedValue)) {
      onChange(selectedValue);
    }
  };
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(SimpleSelect, {
    renderLabel: t('Arrange Outcomes by'),
    value: value,
    onChange: handleChange
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(SimpleSelect.Option, {
      id: option.id,
      value: option.value,
      key: "outcome_arrangement_".concat(option.id)
    }, option.name);
  })), /*#__PURE__*/React.createElement(View, {
    as: "div",
    margin: "xxx-small 0 0 0"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "x-small",
    color: "secondary"
  }, t('(You may drag & drop columns to re-arrange)'))));
};